/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateSecretsDto } from '../../models/update-secrets-dto';

export interface AccountControllerUpdateSecrets$Params {
  accountId: string;
      body: UpdateSecretsDto
}

export function accountControllerUpdateSecrets(http: HttpClient, rootUrl: string, params: AccountControllerUpdateSecrets$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, accountControllerUpdateSecrets.PATH, 'patch');
  if (params) {
    rb.path('accountId', params.accountId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

accountControllerUpdateSecrets.PATH = '/account/{accountId}/secrets';
